import script from "./MainPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./MainPage.vue?vue&type=script&lang=ts&setup=true"

import "./MainPage.vue?vue&type=style&index=0&id=0bf17300&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0bf17300"]])

export default __exports__